// actions
const SET = "menuItems/SET";
const SET_LAST_INDEX = "menuItems/SET_LAST_INDEX";
const SET_NEXT_TOKEN = "menuItems/SET_NEXT_TOKEN";
const SET_PAGINATION = "menuItems/SET_PAGINATION";
const SET_ALL_LISTING = "menuItems/SET_ALL_LISTING";
const SET_SEARCH_TEXT = "menuItems/SET_SEARCH_TEXT";
const SET_DATE = "menuItems/SET_DATE";
const SET_SELECTED = "menuItems/SET_SELECTED";
const CHANGE_LIMIT = "menuItems/CHANGE_LIMIT";
const NEXT_ACTION = "menuItems/NEXT_ACTION";
const SET_PREVIOUS_TOKENS = "menuItems/SET_PREVIOUS_TOKENS";

const DEFAULT_STATE = {
  listing: [],
  allListing: [],
  pagination: [],
  nextToken: null,
  lastIndex: null,
  searchText: "",
  selected: "",
  date: { startDate: new Date(), endDate: new Date() },
  limit: 10,
  previousTokens: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_PAGINATION:
      return Object.assign({}, state, { pagination: action.pagination });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    case SET_LAST_INDEX:
      return Object.assign({}, state, { lastIndex: action.id });
    case SET_ALL_LISTING:
      return Object.assign({}, state, { allListing: action.allListing });
    case SET_SEARCH_TEXT:
      return Object.assign({}, state, { searchText: action.searchText });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_DATE:
      return Object.assign({}, state, { date: action.id });
    case SET_PREVIOUS_TOKENS:
      return Object.assign({}, state, {
        previousTokens: action.previousTokens,
      });
    case CHANGE_LIMIT:
      return Object.assign({}, state, {
        limit: action.limit,
        nextToken: action.nextToken,
        nextNextToken: action.nextNextToken,
        previousTokens: action.previousTokens,
      });
    case NEXT_ACTION:
      return Object.assign({}, state, {
        nextToken: action.nextToken,
        previousTokens: action.previousTokens,
      });

    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setPagination = (pagination: any[]) => ({
  pagination,
  type: SET_PAGINATION,
});
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });
export const setLastIndex = (id: number) => ({ id, type: SET_LAST_INDEX });
export const setAllListing = (allListing: any[]) => ({
  allListing,
  type: SET_ALL_LISTING,
});
export const setSearchText = (searchText: string) => ({
  searchText,
  type: SET_SEARCH_TEXT,
});
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setDate = (id: { startDate: Date; endDate: Date }) => ({
  id,
  type: SET_DATE,
});
export const changeLimit = (limit: any) => ({
  limit: limit,
  nextToken: null,
  nextNextToken: null,
  previousTokens: [],
  type: CHANGE_LIMIT,
});
export const nextAction = (nextToken: any, previousTokens: any[]) => ({
  nextToken: nextToken,
  previousTokens: previousTokens ? [...previousTokens, nextToken] : [nextToken],
  type: NEXT_ACTION,
});
export const setPreviousToken = (previousTokens: any) => ({
  previousTokens,
  type: SET_PREVIOUS_TOKENS,
});
